/**
 * Catálogo centralizado de errores y advertencias (RNF-12). La UI siempre muestra
 * el mensaje accionable más el código.
 */
export type CodigoError =
  | 'ASIS-001' | 'ASIS-002' | 'ASIS-003' | 'ASIS-004' | 'ASIS-005' | 'ASIS-006' | 'ASIS-007'
  | 'ASIS-008' | 'ASIS-009' | 'ASIS-010' | 'ASIS-011' | 'ASIS-012' | 'ASIS-013' | 'ASIS-014'
  | 'INS-001' | 'INS-002' | 'INS-003' | 'INS-004' | 'INS-005' | 'INS-006' | 'INS-007'
  | 'PART-001' | 'PART-002' | 'PART-003' | 'PART-004' | 'PART-005' | 'PART-006' | 'PART-007'
  | 'MJ-001' | 'MJ-002'
  | 'PORTAL-001' | 'PORTAL-002' | 'PORTAL-003'
  | 'NOT-001' | 'NOT-002' | 'NOT-003'
  | 'SEG-001'
  | 'IMP-001' | 'IMP-002' | 'IMP-003' | 'IMP-004' | 'IMP-005' | 'IMP-006' | 'IMP-007'
  | 'AUD-001'
  | 'SYS-001' | 'SYS-002' | 'SYS-003' | 'GEN-001';

export interface DefinicionError {
  severidad: 'BLOQUEO' | 'ADVERTENCIA' | 'INFO';
  mensaje: string;
}

export const ERRORES: Record<CodigoError, DefinicionError> = {
  'ASIS-001': { severidad: 'BLOQUEO', mensaje: 'La persona no tiene una inscripción activa en este ciclo. No es posible registrar su asistencia.' },
  'ASIS-002': { severidad: 'ADVERTENCIA', mensaje: 'La persona pertenece a otro grupo. La asistencia quedará registrada bajo tu nombre en esta clase.' },
  'ASIS-003': { severidad: 'ADVERTENCIA', mensaje: 'La persona ya cumplió este módulo. La asistencia se registra pero no suma de nuevo.' },
  'ASIS-004': { severidad: 'BLOQUEO', mensaje: 'Choque de horario: la persona ya figura presente en otra clase a la misma hora. Coordinación fue notificada.' },
  'ASIS-005': { severidad: 'BLOQUEO', mensaje: 'La sesión está cerrada. Solicita una corrección a coordinación.' },
  'ASIS-006': { severidad: 'BLOQUEO', mensaje: 'La sesión está fuera de la ventana de toma de asistencia.' },
  'ASIS-007': { severidad: 'BLOQUEO', mensaje: 'No eres el mentor asignado a esta sesión.' },
  'ASIS-008': { severidad: 'BLOQUEO', mensaje: 'La persona está retirada del ciclo.' },
  'ASIS-009': { severidad: 'BLOQUEO', mensaje: 'Debes indicar un motivo para continuar.' },
  'ASIS-010': { severidad: 'BLOQUEO', mensaje: 'La sesión está cancelada.' },
  'ASIS-011': { severidad: 'ADVERTENCIA', mensaje: 'Es otro módulo u otro rol: la asistencia quedará registrada pero NO sumará al cumplimiento.' },
  'ASIS-012': { severidad: 'ADVERTENCIA', mensaje: 'Se supera el cupo del grupo más el margen de aforo permitido.' },
  'ASIS-013': { severidad: 'BLOQUEO', mensaje: 'La evidencia fotográfica es obligatoria para guardar la sesión.' },
  'ASIS-014': { severidad: 'BLOQUEO', mensaje: 'La sesión todavía no está abierta para tomar asistencia.' },
  'INS-001': { severidad: 'BLOQUEO', mensaje: 'No encontramos una habilitación con esos datos. Verifica la información o comunícate con coordinación.' },
  'INS-002': { severidad: 'BLOQUEO', mensaje: 'Este enlace no corresponde a tu asignación. Usa el enlace que recibiste de coordinación.' },
  'INS-003': { severidad: 'BLOQUEO', mensaje: 'El grupo ya no tiene cupos disponibles. Elige otro grupo de la lista actualizada.' },
  'INS-004': { severidad: 'BLOQUEO', mensaje: 'Las inscripciones no están abiertas en este momento.' },
  'INS-005': { severidad: 'INFO', mensaje: 'Ya tienes una inscripción activa en este grupo.' },
  'INS-006': { severidad: 'BLOQUEO', mensaje: 'El plazo para cambiar de grupo terminó.' },
  'INS-007': { severidad: 'BLOQUEO', mensaje: 'Debes aceptar el tratamiento de datos personales para inscribirte.' },
  'PART-001': { severidad: 'BLOQUEO', mensaje: 'Ya existe otro participante con ese número de documento.' },
  'PART-002': { severidad: 'BLOQUEO', mensaje: 'El correo electrónico no es válido.' },
  'PART-003': { severidad: 'BLOQUEO', mensaje: 'El celular debe tener 10 dígitos y empezar por 3.' },
  'PART-004': { severidad: 'BLOQUEO', mensaje: 'Otra persona modificó este registro mientras editabas. Recarga para ver la versión actual (tus cambios se conservan en pantalla).' },
  'PART-005': { severidad: 'BLOQUEO', mensaje: 'El cambio de documento, correo o nombre exige un motivo.' },
  'PART-006': { severidad: 'ADVERTENCIA', mensaje: 'El correo no está registrado en Medellín Joven. Se enviará una invitación a crear la cuenta.' },
  'PART-007': { severidad: 'BLOQUEO', mensaje: 'Nombres y apellidos son obligatorios.' },
  'MJ-001': { severidad: 'ADVERTENCIA', mensaje: 'El servicio de Medellín Joven no respondió. Intenta de nuevo más tarde.' },
  'MJ-002': { severidad: 'ADVERTENCIA', mensaje: 'El correo está registrado en Medellín Joven con un documento distinto.' },
  'PORTAL-001': { severidad: 'INFO', mensaje: 'Inicia sesión para ver tu progreso.' },
  'PORTAL-002': { severidad: 'INFO', mensaje: 'No tienes formaciones Music Lab activas.' },
  'PORTAL-003': { severidad: 'INFO', mensaje: 'Aún no hay clases transcurridas en tu ciclo.' },
  'NOT-001': { severidad: 'ADVERTENCIA', mensaje: 'El correo fue suprimido.' },
  'NOT-002': { severidad: 'BLOQUEO', mensaje: 'La plantilla de correo es inválida o le falta una variable.' },
  'NOT-003': { severidad: 'ADVERTENCIA', mensaje: 'El envío falló; se programó un reintento.' },
  'SEG-001': { severidad: 'BLOQUEO', mensaje: 'Tu rol no permite realizar esta acción.' },
  'IMP-001': { severidad: 'BLOQUEO', mensaje: 'Faltan columnas obligatorias en el archivo.' },
  'IMP-002': { severidad: 'BLOQUEO', mensaje: 'Documento vacío o con formato inválido.' },
  'IMP-003': { severidad: 'BLOQUEO', mensaje: 'Fila duplicada dentro del archivo.' },
  'IMP-004': { severidad: 'BLOQUEO', mensaje: 'Rol, nivel o grupo inexistente.' },
  'IMP-005': { severidad: 'BLOQUEO', mensaje: 'Fecha u hora con formato inválido.' },
  'IMP-006': { severidad: 'BLOQUEO', mensaje: 'Cupo inválido.' },
  'IMP-007': { severidad: 'ADVERTENCIA', mensaje: 'Posible duplicado de persona (mismo correo con otro documento).' },
  'AUD-001': { severidad: 'BLOQUEO', mensaje: 'No fue posible registrar la auditoría; el cambio no se guardó.' },
  'SYS-001': { severidad: 'BLOQUEO', mensaje: 'Error de almacenamiento local.' },
  'SYS-002': { severidad: 'BLOQUEO', mensaje: 'Se superó la cuota de almacenamiento del navegador.' },
  'SYS-003': { severidad: 'BLOQUEO', mensaje: 'La transacción se revirtió; no se guardó ningún cambio.' },
  'GEN-001': { severidad: 'BLOQUEO', mensaje: 'Datos inválidos.' }
};

export interface Hallazgo {
  codigo: CodigoError;
  mensaje: string;
}

export function hallazgo(codigo: CodigoError, mensaje?: string): Hallazgo {
  return { codigo, mensaje: mensaje ?? ERRORES[codigo].mensaje };
}

export interface Evaluacion {
  bloqueos: Hallazgo[];
  advertencias: Hallazgo[];
}

export const EVALUACION_OK: Evaluacion = { bloqueos: [], advertencias: [] };

export type Resultado<T> =
  | { estado: 'OK'; valor: T; secuencia?: number }
  | { estado: 'ERROR'; error: Hallazgo; detalle?: string }
  | { estado: 'CONFIRMAR'; advertencias: Hallazgo[] };

export function ok<T>(valor: T, secuencia?: number): Resultado<T> {
  return { estado: 'OK', valor, secuencia };
}

export function falla<T>(codigo: CodigoError, mensaje?: string, detalle?: string): Resultado<T> {
  return { estado: 'ERROR', error: hallazgo(codigo, mensaje), detalle };
}

/** Error de dominio lanzado dentro de una transacción para revertirla con un código. */
export class ErrorDominio extends Error {
  constructor(public readonly codigo: CodigoError, mensaje?: string) {
    super(mensaje ?? ERRORES[codigo].mensaje);
    this.name = 'ErrorDominio';
  }
}
